<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">抽奖</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="top"></div>
    <div class="tip ub ub-ac">
         <span>你还有45次抽奖机会</span>
    </div>

        <div class="lucky ub ub-ver ub-pc">
             <ul id="rotary_table">
                  <li v-for="(item, index) in awards" :key="index" :class="['award' + index, { active: index == current }]" class="award">
                      <img :src="item.img" alt />
                      <div class="mask" v-if="index == current"></div>
                  </li>
                  <div id="start-btn" @click="start"></div>
              </ul>
        </div>
    
    <div class="ub ub-ac" style="background-color: #3196ff;">
        <img src="../assets/img/lottery/prizers.png" class="prizers"/>
    </div>
    <div class="prizeIcon ub ub-pc ub-ac">
        <div class="ub ub-ver ub-pc" style=" background-color: #fff;margin: 0 2.5rem;">
            <img src="../assets/img/lottery/prizeIcon.png"/>
            <div style="overflow: hidden;">
            <div class="inner-container">
            <div style="font-size: 0.7rem; margin-top: 1rem;" v-for="(item, index) in luc" :key="index" >
             <span>恭喜&nbsp;&nbsp;"<label style="color: red">{{item.nick}}</label>"&nbsp;&nbsp;抽中了&nbsp;&nbsp;"<label style="color: #e92162">{{item.lucky}}</label>"</span>
              <span style="color: #888">{{item.dtm}}</span>
         </div>
          </div>
           </div>
        </div>
    </div>

    <div class="comm ub ub-ver ub-pc">
        <div class="ub ub-ac ub-pc">
            <img class="three" src="../assets/img/lottery/three.png" alt="">
            <span class="sp1">奖品说明</span>
            <img class="three" src="../assets/img/lottery/three.png" alt="">
        </div>
       
        <div class="comm2 ub ub-ver ub-ps">
            <div class="ub ub-pc">
                <img src="../assets/img/lottery/point.png" alt="">
                <span>每人每天限50次抽奖机会。</span>
            </div>
            <div class="ub ub-pc">
                <img src="../assets/img/lottery/point.png" alt="">
                <span>一等奖超级会员年费</span>
            </div>
        </div>
    </div>

    <div class="comm ub ub-ver ub-pc" style="padding-bottom:3em">
        <div class="ub ub-ac ub-pc">
            <img class="three" src="../assets/img/lottery/three.png" alt="">
            <span class="sp1">活动说明</span>
            <img class="three" src="../assets/img/lottery/three.png" alt="">
        </div>
       
        <div class="comm2 ub ub-ver ub-ps">
            <div class="ub ub-pc">
                <img src="../assets/img/lottery/point.png" alt="">
                <span>每人每天限50次抽奖机会。</span>
            </div>
            <div class="ub ub-pc">
                <img src="../assets/img/lottery/point.png" alt="">
                <span>一等奖超级会员年费</span>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../components/Form.vue";

export default {
  data() {
    return{
            awards: [
                // 图片名字与ID
                { id: 1, name: '手机' , img : require('@/assets/img/lottery/prizeSmall/1.png')},
                { id: 2, name: '200优惠劵' , img : require('@/assets/img/lottery/prizeSmall/2.png')},
                { id: 3, name: '310优惠劵' ,img : require('@/assets/img/lottery/prizeSmall/3.png')},
                { id: 4, name: '240优惠劵' ,img : require('@/assets/img/lottery/prizeSmall/4.png')},
                { id: 5, name: '230优惠劵',img : require('@/assets/img/lottery/prizeSmall/5.png') },
                { id: 6, name: '220优惠劵',img : require('@/assets/img/lottery/prizeSmall/6.png') },
                { id: 7, name: '210优惠劵' ,img : require('@/assets/img/lottery/prizeSmall/7.png')},
                { id: 8, name: '200优惠劵' ,img : require('@/assets/img/lottery/prizeSmall/8.png')}
            ],
            current: -1, // 当前索引值 
            speed: 200, // 时间->速度
            diff: 15, // 基数 转动的圈数
            award: {}, // 抽中的奖品
            time: 0, // 当前时间戳
            timer: null, // 定时器

            havePrizeShow : false,
            luc:[
    {
        "nick":"仙女爷爷",
        "lucky":"200金币",
        "dtm":"2分钟前"
    },
    {
        "nick":"暗里着迷",
        "lucky":"VIP七天",
        "dtm":"5分钟前"
    },
    {
        "nick":"喵咕酱",
        "lucky":"200积分",
        "dtm":"6分钟前"
    },
    {
        "nick":"小可爱1号",
        "lucky":"500金币",
        "dtm":"8分钟前"
    },
    {
        "nick":"木冇鱼丸",
        "lucky":"VIP一天",
        "dtm":"12分钟前"
    }
]
        }
  },
  mounted() {},
  methods: {
        back() {
      this.$router.go(-1); //返回上一层
    },
        // 开始抽奖
        start() {
            // 开始抽奖
            this.getLottery();
            this.time = Date.now();  //设置定时器
            this.speed = 200;
            this.diff = 8;
        },
        // 调接口获取奖品
        getLottery() {
            this.award.name = "210优惠劵";
            this.award.id = 7;
            this.move();
            
        },
        // 开始转动
        move() {
            this.timer = setTimeout(() => {
                this.current++; //选中的遮罩层
                if (this.current > 7) {
                    this.current = 0;
                }
                // 若抽中的奖品id存在，则开始减速转动
                if (this.award.id && (Date.now() - this.time) / 1000 > 2) {
                    this.speed += this.diff; // 转动减速
                    // 若转动时间超过4秒，并且奖品id等于小格子的奖品id，则停下来
                    if (
                        (Date.now() - this.time) / 1000 > 4 &&
                        this.award.id == this.awards[this.current].id
                    ) {
                        clearTimeout(this.timer);
                        setTimeout(() => {
                            // Toast(`恭喜中奖${this.award.name}元`);
                            alert(`恭喜中奖${this.award.name}`)
                            this.havePrizeShow = true;
                        }, 0);
                        return;
                    }
                } 
                else {
                    // 若抽中的奖品不存在，则加速转动
                    this.speed -= this.diff;
                }

                this.move();
            }, this.speed);

        },
    }
};
</script>

<style lang="scss" scoped>
.top{
    height: 9.5rem;
   background: url("../assets/img/lottery/banner.png")
   no-repeat center/100%;
   background-color: #3196ff;
}
.tip{
    background-color: #3196ff;
    span{
        color: #fff;
        background-color: #ff7a00;
        padding:.5rem 1.2rem;
        border-radius: 1rem;
    }
}
.lucky{
     background-color: #3196ff;
     #rotary_table{
        width: 18rem;
        height: 20rem;
        position: relative;
        background-color: #fff;
        border-radius: .8rem;
    }
    .award {
        width: 5.4rem;
        height: 5.4rem;
        text-align: center;
        float: left;
        position: absolute;
        overflow: hidden;
        img {
            position: absolute;
            width: 5rem;
            top: 0;
            left: 0;
            height: 5rem;
        }
    }
    #start-btn {
        position: absolute;
        width: 5rem;
        height: 5rem;
        top: 7.8rem;
        left: 7.8rem;
        border-radius: 50%;
        text-align: center;
        background: url("../assets/img/lottery/prizeBtn.png")
        no-repeat center/100%;
    }
    .active  .mask {
        width: 5.4rem;
        height: 5.4rem;
        background: url("../assets/img/lottery/borderSelect.png")
            no-repeat center/100%;
        position: absolute;
        border-radius: 10px;
        background-color: #fff0bd;
        opacity: 0.6;
    }
}



.prizers{
    width: 90%;
    height: 1rem;
    margin: 2rem 0 0 0;
}
.prizeIcon{
    background-color: #3196ff;
    img{
        width: 78%;
    }
    .inner-container {
        animation: myMove 5s linear infinite;
        animation-fill-mode: forwards;
    }
    @keyframes myMove {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(-100px);
    }
    }
}
.comm{
   background-color: #3196ff;
   color: #fff;
   padding-top: 1.5rem;
   .sp1{
        font-weight: 700;  
        padding: .8rem 0;
    }
    .three{
        height: .3rem;
        margin: 0 .8rem;
    }
    .comm2{
        background-color: #62abff;
        width: 87%;
        font-size: .9rem;
        padding: .8rem;
        img{
            height: .3rem;
            margin-right: 1rem;
        }
        div{
            margin: .3rem 0;
        }
    }
}


</style>